import React, { useState, useEffect } from "react";
// import * as XLSX from 'xlsx';
import {
  GetByDatesMotivation,
  PostMotivation,
  PatchMotivation,
  DonwloadMotivation,
} from "./../../api/reports/motivation";

const Motivation = ({ token, accessLevel }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [haveReport, setHaveReport] = useState(false);
  const [report, setReport] = useState({});
  const [modalMessage, setModalMessage] = useState("");
  const [workSpinner, setWorkSpinner] = useState(false);

  const DefaultFields = [
    ["result_HI", "show_name", ""], //0
    ["premium_HI", "show_name 2", ""], //
    ["result_POST", "show_name 2", ""], //2
    ["premium_POST", "show_name 2", ""],
    ["result_TMT", "show_name 2", ""], // 4
    ["premium_TMT", "show_name 2", ""],
    ["result_POSTMOSCOW", "show_name 2", ""], // 6
    ["premium_POSTMOSCOW", "show_name 2", ""],
    ["result_EBITDA", "show_name 2", ""], // 8
    ["premium_EBITDA", "show_name 2", ""],
    ["summa", "show_name 2", ""], // 10
    ["premium_col", "show_name 2", ""], // 11
    ["col", "show_name 2", ""], // 12
    ["to", "show_name 2", ""], // 13
    ["fot", "show_name 2", ""], // 14
    ["fot_del_to", "show_name 2", ""], // 15
    ["premium_HI_zam", "show_name 2", ""], // 16
    ["premium_POST_zam", "show_name 2", ""], // 17
    ["premium_TMT_zam", "show_name 2", ""], // 18
    ["premium_POSTMOSCOW_zam", "show_name 2", ""], // 19
    ["premium_EBITDA_zam", "show_name 2", ""], //20
    ["premium_col_zam", "show_name 2", ""], // 21
    ["summa_zam", "show_name 2", ""], // 22
    ["TO_premium_dir", "show_name 2", ""], // 23
    ["TO_premium_zam", "show_name 2", ""], // 24
    ["training_restaurant", "show_name 2", ""], // 25
    ["training_restaurant_premium", "show_name 2", ""], // 26
    ["data_mng", "show_name 2", ""], // 27
    ["data_zam", "show_name 2", ""], // 28
    ["data_dir", "show_name 2", ""], // 29
    ["count_mng", "show_name 2", ""], // 29
    ["count_zam", "show_name 2", ""], // 29
    ["count_dir", "show_name 2", ""], // 29
    ["premium_mng", "show_name 2", ""], // 30
    ["premium_zam", "show_name 2", ""], // 30
    ["premium_dir", "show_name 2", ""], // 30
  ];

  const [fields, setFields] = useState(DefaultFields);

  const GetByDates = GetByDatesMotivation;
  const Create = PostMotivation;
  const Update = PatchMotivation;

  const loading = async () => {
    try {
      // const rep = await GetByDates(token, startDate, endDate)
      // if (rep.length > 0){
      //   // console.log(123123)
      //   setHaveReport(true)
      // setReport(rep[0])
      // setFields(rep[0].fields)
      // }
    } catch (err) {
      console.error(err);
    }
  };

  function returnValue(code) {
    for (let field of fields) {
      if (field[0] === code) {
        if (field[2] || field[2] === 0) {
          return field[2];
        }
        return;
      }
    }
  }

  function updateValue(code, value) {
    if (!value) {
      value = 0;
    }
    for (let field in fields) {
      if (fields[field][0] === code) {
        updateFieldValue(field, value);
        return;
      }
    }
  }

  useEffect(() => {
    loading();
  }, [token]);

  async function loadRepost() {
    if (!startDate || !endDate) {
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      setWorkSpinner(false);
      return;
    }
    const rep = await GetByDates(token, startDate, endDate);
    // console.log(rep, rep.length > 0)
    console.log(rep, "что выгружается");
    if (rep.length === 0) {
      setModalMessage(<p>Ничего нет, заполняйте</p>);
    }
    if (rep.length === 1) {
      let fields = DefaultFields;

      for (let field of fields) {
        for (let repField of rep[0].fields) {
          if (field[0] == repField[0]) {
            field[2] = repField[2];
            if (parseFloat(field[2]) || parseFloat(field[2]) === 0) {
              field[2] = parseFloat(field[2]);
            }
            break;
          }
        }
      }

      const legacyOsat = rep[0].fields.find((f) => f[0] === "result_OSAT");
      const hiField = fields.find((f) => f[0] === "result_HI");
      if (legacyOsat && hiField && !hiField[2] && hiField[2] !== 0) {
        hiField[2] = legacyOsat[2];
        if (parseFloat(hiField[2]) || parseFloat(hiField[2]) === 0) {
          hiField[2] = parseFloat(hiField[2]);
        }
      }
      console.log(fields);

      setHaveReport(true);
      setReport(rep[0]);
      // setFields(rep[0].fields);
      setFields(fields);
      setModalMessage(<p style={{ color: "green" }}>Выгружено!</p>);
    }
    setWorkSpinner(false);
  }

  async function download() {
    const response = await DonwloadMotivation(token, startDate, endDate);
    if (!startDate || !endDate) {
      setWorkSpinner(false);
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      return;
    }
    // setWorkSpinner(true)
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = `motivation_${startDate}_${endDate}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
      if (filenameMatch?.[1]) {
        filename = filenameMatch[1].trim();
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
    setModalMessage(<p style={{ color: "green" }}>Отчет скачен!</p>);
    setWorkSpinner(false);
  }

  async function saveReport() {
    if (!startDate || !endDate) {
      setWorkSpinner(false);
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      return;
    }

    if (haveReport) {
      const data = await Update(token, report.id, {
        fields: fields,
      });
      console.log(data);
      if (data.detail) {
        setWorkSpinner(false);
        setModalMessage(<p style={{ color: "red" }}>{data.detail}</p>);
        return;
      }
      setReport(data);
      setModalMessage(<p style={{ color: "green" }}>Отчет обновлен!</p>);
    } else {
      const data = await Create(token, {
        report_id: 1,
        start_date: startDate,
        end_date: endDate,
        fields: fields,
      });
      if (data.detail) {
        console.log(data.detail);
        setModalMessage(<p style={{ color: "red" }}>{data.detail}</p>);

        return;
      }
      setReport(data);
      setHaveReport(true);
      setModalMessage(<p style={{ color: "green" }}>Отчет создан!</p>);
    }
    setWorkSpinner(false);
  }

  const updateFieldValue = (rowIndex, newValue) => {
    setFields((prevFields) =>
      prevFields.map((row, i) =>
        i === parseInt(rowIndex)
          ? row.map((cell, j) => (j === 2 ? newValue : cell))
          : [...row],
      ),
    );
  };

  function calculateHIPremium(hi) {
    if (hi === undefined || hi === null || hi === "") {
      return { dir: 0, zam: 0 };
    }
    if (hi < 40) {
      return { dir: -3000, zam: -2000 };
    }
    if (hi < 70) {
      return { dir: 5000, zam: 2500 };
    }
    return { dir: 10000, zam: 5000 };
  }

  useEffect(() => {
    const value = returnValue("result_HI");
    const premiums = calculateHIPremium(value);
    updateValue("premium_HI", premiums.dir);
    updateValue("premium_HI_zam", premiums.zam);
  }, [returnValue("result_HI")]);

  useEffect(() => {
    const value = returnValue("result_POST");
    if (value === 1) {
      updateValue("premium_POST", 7000);
      updateValue("premium_POST_zam", 4000);
    } else if (value === 2) {
      updateValue("premium_POST", 5000);
      updateValue("premium_POST_zam", 2500);
    } else {
      updateValue("premium_POST", 0);
      updateValue("premium_POST_zam", 0);
    }
  }, [returnValue("result_POST")]);

  useEffect(() => {
    const value = returnValue("result_TMT");
    if (value <= 90) {
      updateValue("premium_TMT", 5000);
      updateValue("premium_TMT_zam", 2500);
    } else {
      updateValue("premium_TMT", -3000);
      updateValue("premium_TMT_zam", -2000);
    }
  }, [returnValue("result_TMT")]);

  useEffect(() => {
    const value = returnValue("result_POSTMOSCOW");
    if (value === 1) {
      updateValue("premium_POSTMOSCOW", 20000);
      updateValue("premium_POSTMOSCOW_zam", 10000);
    } else if (value === 2) {
      updateValue("premium_POSTMOSCOW", 10000);
      updateValue("premium_POSTMOSCOW_zam", 7000);
    } else if (value === 3) {
      updateValue("premium_POSTMOSCOW", -5000);
      updateValue("premium_POSTMOSCOW_zam", -2000);
    } else if (value === 4) {
      updateValue("premium_POSTMOSCOW", -10000);
      updateValue("premium_POSTMOSCOW_zam", -7000);
    } else if (value === 5) {
      updateValue("premium_POSTMOSCOW", -20000);
      updateValue("premium_POSTMOSCOW_zam", -15000);
    } else {
      updateValue("premium_POSTMOSCOW", 0);
      updateValue("premium_POSTMOSCOW_zam", 0);
    }
  }, [returnValue("result_POSTMOSCOW")]);

  useEffect(() => {
    const EBITDA = returnValue("result_EBITDA");
    updateValue("premium_EBITDA", EBITDA * 0.01);
    updateValue("premium_EBITDA_zam", EBITDA * 0.005);
  }, [returnValue("result_EBITDA")]);

  // useEffect(() => {
  //   const training_restaurant = returnValue("training_restaurant");
  //   if (training_restaurant === 1) {
  //     updateValue("training_restaurant_premium", 11500);
  //     return;
  //   }
  //   updateValue("training_restaurant_premium", 0);
  // }, [returnValue("training_restaurant")]);

  // Премия за выращенных сотрудников
  useEffect(() => {
    const countMng = returnValue("count_mng");
    const countZam = returnValue("count_zam");
    const countDir = returnValue("count_dir");
    updateValue("premium_mng", countMng * 3000);
    updateValue("premium_zam", countZam * 5000);
    updateValue("premium_dir", countDir * 8000);
  }, [
    returnValue("count_mng"),
    returnValue("count_zam"),
    returnValue("count_dir"),
  ]);

  useEffect(() => {
    let fot_del_to = 0;
    const TO = returnValue("to");
    const fot = returnValue("fot");
    const col = returnValue("col");

    console.log(TO, fot, col);

    if (TO > 0) {
      if (TO >= 16000000) {
        updateValue("TO_premium_dir", 10000);
        updateValue("TO_premium_zam", 5000);
      } else {
        updateValue("TO_premium_dir", 0);
        updateValue("TO_premium_zam", 0);
      }
    }
    if (TO && fot) {
      fot_del_to = (fot / TO) * 100;
      updateFieldValue(15, fot_del_to ? fot_del_to.toFixed(2) : fot_del_to);
    }
    if (TO && fot && fot_del_to) {
      if (col > fot_del_to) {
        updateValue("premium_col", 7000);
        updateValue("premium_col_zam", 4000);
      } else {
        updateValue("premium_col", 0);
        updateValue("premium_col_zam", 0);
      }
    }
  }, [returnValue("col"), returnValue("to"), returnValue("fot")]);

  useEffect(() => {
    const total =
      (returnValue("premium_HI") || 0) +
      (returnValue("premium_POST") || 0) +
      (returnValue("premium_TMT") || 0) +
      (returnValue("premium_POSTMOSCOW") || 0) +
      (returnValue("premium_EBITDA") || 0) +
      (returnValue("premium_col") || 0) +
      (returnValue("TO_premium_dir") || 0) +
      (returnValue("premium_mng") || 0) +
      (returnValue("premium_zam") || 0) +
      // (returnValue("training_restaurant_premium") || 0) +
      (returnValue("premium_dir") || 0);
    console.log(total);
    updateValue("summa", total ? total.toFixed(2) : total);

    const totalZam =
      (returnValue("premium_HI_zam") || 0) +
      (returnValue("premium_POST_zam") || 0) +
      (returnValue("premium_TMT_zam") || 0) +
      (returnValue("premium_POSTMOSCOW_zam") || 0) +
      (returnValue("premium_EBITDA_zam") || 0) +
      (returnValue("premium_col_zam") || 0) +
      (returnValue("TO_premium_zam") || 0) +
      (returnValue("premium_zam") || 0);
    // (returnValue("training_restaurant_premium") || 0) +
    // (returnValue("premium_dir") || 0);
    // (parseFloat(fields[16]?.[2]) || 0) +
    // (parseFloat(fields[17]?.[2]) || 0) +
    // (parseFloat(fields[18]?.[2]) || 0) +
    // (parseFloat(fields[19]?.[2]) || 0) +
    // (parseFloat(fields[20]?.[2]) || 0) +
    // (parseFloat(fields[21]?.[2]) || 0);

    // updateFieldValue(22, totalZam ? totalZam.toFixed(2).toString() : totalZam);
    updateValue("summa_zam", totalZam ? totalZam.toFixed(2) : totalZam);
    // parseFloat(fields[1]?.[2]) || 0 +    )
  }, [
    returnValue("premium_HI"),
    returnValue("premium_POST"),
    returnValue("premium_TMT"),
    returnValue("premium_POSTMOSCOW"),
    returnValue("premium_EBITDA"),
    returnValue("premium_col"),
    returnValue("TO_premium_dir"),
    returnValue("TO_premium_zam"),
    returnValue("premium_HI_zam"),
    returnValue("premium_POST_zam"),
    returnValue("premium_TMT_zam"),
    returnValue("premium_POSTMOSCOW_zam"),
    returnValue("premium_EBITDA_zam"),
    returnValue("premium_col_zam"),
    returnValue("training_restaurant_premium"),
    returnValue("premium_mng"),
    returnValue("premium_zam"),
    returnValue("premium_dir"),
  ]);

  useEffect(() => {
    console.log("upd dates");
    setReport({});
    setHaveReport(false);
    setFields(DefaultFields);
  }, [startDate, endDate]);

  function renderTable(data) {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th></th>
            <th>Цель</th>
            <th>Результат</th>
            <th>Премия директора</th>
            <th>Премия зам. директора</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1. HI</td>
            <td>
              &gt;=70
            </td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("result_HI")}
                onChange={(e) =>
                  updateValue("result_HI", parseFloat(e.target.value))
                }
              />
            </td>
            <td>{returnValue("premium_HI")}</td>
            <td>{returnValue("premium_HI_zam")}</td>
          </tr>
          <tr>
            <td>2. РОСТ self</td>
            <td>at standart</td>
            <td>
              <select
                className="form-control"
                name=""
                id=""
                value={returnValue("result_POST")}
                onChange={(e) =>
                  updateValue("result_POST", parseInt(e.target.value))
                }
              >
                <option value="">Не выбрано</option>
                <option value={1}>A</option>
                <option value={2}>B</option>
              </select>
            </td>
            <td>{returnValue("premium_POST")}</td>
            <td>{returnValue("premium_POST_zam")}</td>
          </tr>
          <tr>
            <td>3. TMT</td>
            <td> &lt;= 90</td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("result_TMT")}
                onChange={(e) =>
                  updateValue("result_TMT", parseFloat(e.target.value))
                }
              />
            </td>
            <td>{returnValue("premium_TMT")}</td>
            <td>{returnValue("premium_TMT_zam")}</td>
          </tr>
          <tr>
            <td>4. РОСТ Москва</td>
            <td>A, B</td>
            <td>
              <select
                className="form-control"
                name=""
                id=""
                value={returnValue("result_POSTMOSCOW")}
                onChange={(e) =>
                  updateValue("result_POSTMOSCOW", parseInt(e.target.value))
                }
              >
                <option value="">Не выбрано</option>
                <option value="1">A</option>
                <option value="2">B</option>
                <option value="3">C</option>
                <option value="4">D</option>
                <option value="5">F</option>
              </select>
            </td>
            <td>{returnValue("premium_POSTMOSCOW")}</td>
            <td>{returnValue("premium_POSTMOSCOW_zam")}</td>
          </tr>
          <tr>
            <td>5. EBITDA</td>
            <td>Индивидуально</td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("result_EBITDA")}
                onChange={(e) =>
                  updateValue("result_EBITDA", parseInt(e.target.value))
                }
              />
            </td>
            <td>
              {returnValue("premium_EBITDA")
                ? parseFloat(returnValue("premium_EBITDA")).toFixed(2)
                : returnValue("premium_EBITDA")}
            </td>
            <td>
              {returnValue("premium_EBITDA_zam")
                ? parseFloat(returnValue("premium_EBITDA_zam")).toFixed(2)
                : returnValue("premium_EBITDA_zam")}
            </td>
          </tr>
          <tr>
            <td>6. ТО</td>
            <td>TO &gt;= 16 млн</td>
            <td>
              <input
                type="text"
                className="form-control"
                value={returnValue("to")}
                onChange={(e) => {
                  updateValue("to", parseFloat(e.target.value));
                }}
              />
            </td>
            <td>{returnValue("TO_premium_dir")}</td>
            <td>{returnValue("TO_premium_zam")}</td>
          </tr>
          <tr>
            <td>7. COL</td>
            {/* <td></td> */}
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("col")}
                onChange={(e) => updateValue("col", parseFloat(e.target.value))}
              />
            </td>
            <td>{returnValue("fot_del_to")}</td>
            <td>{returnValue("premium_col")}</td>
            <td>{returnValue("premium_col_zam")}</td>
          </tr>
          <tr>
            <td>Обучающий ресторан</td>
            <td>Да \ нет</td>
            <td>
              <select
                className="form-control"
                value={returnValue("training_restaurant")}
                onChange={(e) =>
                  updateValue("training_restaurant", parseInt(e.target.value))
                }
              >
                <option value="">Не выбрано</option>
                <option value="1">Да</option>
                <option value="0">Нет</option>
              </select>
            </td>

            <td colSpan={2}></td>
            {/* <td>0</td> */}
          </tr>
          <tr>
            <td>Сумма</td>
            <td colSpan={2}></td>

            <td>{returnValue("summa")}</td>
            <td>{returnValue("summa_zam")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderTable2() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th>Поле</th>
            <th>Значение</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ФОТ</td>
            <td>
              <input
                type="text"
                className="form-control"
                value={returnValue("fot")}
                onChange={(e) => updateValue("fot", parseFloat(e.target.value))}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderTable3() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th>Должность</th>
            <th>Данные</th>
            <th>Количество</th>
            <th>Премия</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>МНГ</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("data_mng")}
                onChange={(e) => updateValue("data_mng", e.target.value)}
              />
            </td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("count_mng")}
                onChange={(e) =>
                  updateValue("count_mng", parseInt(e.target.value))
                }
              />
            </td>
            <td>{returnValue("premium_mng")}</td>
          </tr>
          <tr>
            <td>Заместителей</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("data_zam")}
                onChange={(e) => updateValue("data_zam", e.target.value)}
              />
            </td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("count_zam")}
                onChange={(e) =>
                  updateValue("count_zam", parseInt(e.target.value))
                }
              />
            </td>
            <td>{returnValue("premium_zam")}</td>
          </tr>
          <tr>
            <td>Директоров</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("data_dir")}
                onChange={(e) => updateValue("data_dir", e.target.value)}
              />
            </td>
            <td>
              <input
                type="number"
                className="form-control"
                value={returnValue("count_dir")}
                onChange={(e) =>
                  updateValue("count_dir", parseInt(e.target.value))
                }
              />
            </td>
            <td>{returnValue("premium_dir")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по Мотивации</h1>
        </div>
        <div className="col-md-5 row" style={{ marginTop: "3%" }}>
          <label htmlFor="" className="col-md-5 col-form-label">
            Начальная дата:
          </label>
          <div className="col-md-7">
            <input
              className="form-control"
              type="date"
              name=""
              id=""
              onChange={(e) => setStartDate(e.target.value)}
              value={startDate}
            />
          </div>
        </div>

        <div className="col-md-5 row" style={{ marginTop: "3%" }}>
          <label htmlFor="" className="col-md-5 col-form-label">
            Конечная дата:
          </label>
          <div className="col-md-7">
            <input
              className="form-control"
              type="date"
              name=""
              id=""
              onChange={(e) => setEndDate(e.target.value)}
              value={endDate}
            />
          </div>
        </div>

        <div className="col-md-2" style={{ marginTop: "3%" }}>
          <button
            className="btn"
            onClick={() => {
              setWorkSpinner(true);
              loadRepost();
            }}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Выгрузить
          </button>
          {/* <button onClick={downloadExcel}>xlsx</button> */}
        </div>
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        {renderTable(1)}
        {renderTable2()}
        {renderTable3()}
      </div>
      <div className="row">
        <div className="col-md-2">
          <button
            className="btn"
            onClick={() => {
              setWorkSpinner(true);
              saveReport();
            }}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Сохранить
          </button>
        </div>
        <div className="col-md-2">
          {accessLevel > 12 && (
            <button
              className="btn"
              onClick={() => {
                setWorkSpinner(true); // Первое действие
                download(); // Второе действие
              }}
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Скачать
            </button>
          )}
        </div>

        <div className="row">
          <div className="col-md-6">
            {report["creater_name"] && (
              <>
                Создано{" "}
                {`${report["creater_name"]} ${report["creater_surname"]}`} в{" "}
                {report["created"]}
              </>
            )}
          </div>
          <div className="col-md-6">
            {report["updater_name"] && (
              <>
                Последнее обновление{" "}
                {`${report["updater_name"]} ${report["updater_surname"]}`} в{" "}
                {report["updated"]}
              </>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title text-center" id="staticBackdropLabel">
                Информация
              </h5>
            </div>
            <div className="modal-body text-center">
              {workSpinner && (
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}

              {modalMessage}
              {/* <p className="text-center">{message[0]}</p>
                    <p className="text-center">{message[1]}</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Motivation;
